import React, { useState, useEffect } from "react";
import SelectDropdown from "../Components/shared/SelectDropdown";
import Input from "../Components/shared/Input";
import { fetchFormData, fetchData } from "./options";
import topTost from "./topTost";
const InquiryStageModal = ({
  show,
  onClose,
  onConfirm,
  inquiryStageData,
  selectedInquiryId,
  selectedInquiryStage,
}) => {
  const userId = localStorage.getItem("id");
  const [animate, setAnimate] = useState(false);
  const [bank, setBank] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [isConverted, setIsConverted] = useState(false);
  const [inquiryStage, setInquiryStage] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    id: "",
    is_converted: "",
    converted_date: "",
    LoanApplicationNumber: "",
    PreferBank: "",
    title: "",
  });

  useEffect(() => {
    setInquiryStage(selectedInquiryStage);
  }, [selectedInquiryStage]);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetchData("getallbankDropdown", {}, "GET");

        if (response && response.data) {
          const formattedBanks = response.data.map((item) => ({
            label: item.lender_name,
            value: item.id,
          }));
          setBank(formattedBanks);
        }
      } catch (error) {
        console.error("Failed to fetch bank data", error);
      }
    };

    if (show) {
      fetchBanks();
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 300); // same as your CSS animation duration
      return () => clearTimeout(timer);
    }
  }, [show]);
  const handleStatusChange = (selected) => {
    if (selected) {
      setInquiryStage(selected.value);
    }
  };

  const handleBankChange = (selected) => {
    if (selected) {
      setSelectedBankId(selected.value);
    }
  };

  const handleChange = (key, value) => {
    setData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleCancel = () => {
    onClose?.(); // Close the modal
    window.location.reload(); // Reload the page
  };

  const handleSubmit = async () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("id", selectedInquiryId);
    formData.append("is_converted", isConverted ? 1 : 0);
    formData.append(
      "converted_date",
      isConverted ? new Date().toISOString().slice(0, 10) : ""
    );
    formData.append("LoanApplicationNumber", data.LoanApplicationNumber || "");
    formData.append("status", inquiryStage || 1);
    formData.append("userId", userId);
    formData.append("PreferBank", data.PreferBank);
    formData.append("title", data.title);
    try {
      const response = await fetchFormData(
        "update-IsConverted",
        formData,
        "POST"
      );

      if (response?.code === 200 || response?.code === 201) {
        topTost({
          title: response.message || "Inquiry updated successfully!",
          icon: "success",
        });
        setTimeout(() => {
          window.location.reload();
        }, 600);
      } else {
        topTost({
          title: response.message || "",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      topTost({
        title: "Something went wrong!",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`modal ${show ? "d-block" : "d-none"}`}
      tabIndex="-1"
      role="dialog"
      style={{
        pointerEvents: show ? "auto" : "none",
        backdropFilter: "blur(4px)",
      }}
    >
      <div
        className={`modal-dialog modal-dialog-centered ${
          animate ? "animate-slide" : ""
        }`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Inquiry Stage</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleCancel}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3 d-flex">
              <div className="col-md-4">
                <label className="fw-semibold">Inquiry Stage:</label>
              </div>
              <div className="col-lg-8">
                <SelectDropdown
                  options={inquiryStageData}
                  selectedOption={
                    inquiryStageData.find(
                      (opt) => opt.value === inquiryStage
                    ) || null
                  }
                  defaultSelect={"Select Loan Stage"}
                  onSelectOption={handleStatusChange}
                  icon="feather-settings"
                  value={inquiryStage}
                />
              </div>
            </div>
            <div className="form-check mb-3 ">
              <input
                className="form-check-input"
                type="checkbox"
                id="convertedCheckbox"
                checked={isConverted}
                onChange={(e) => setIsConverted(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="convertedCheckbox">
                Is Converted
              </label>
            </div>
            {isConverted && (
              <>
                <div className="mb-3">
                  <Input
                    label="Application ID"
                    id="LoanApplicationNumber"
                    type="text"
                    placeholder="Enter Loan Application name or number"
                    value={data.LoanApplicationNumber}
                    onChange={handleChange}
                    name="LoanApplicationNumber"
                    icon="feather-hash"
                  />
                </div>

                <div className="row mb-3">
                  <div className="col-4">
                    <label className="fw-semibold">Lender Bank:</label>
                  </div>
                  <div className="col-8">
                    <SelectDropdown
                      options={bank}
                      value={data.PreferBank}
                      selectedOption={
                        bank.find((opt) => opt.value === data.PreferBank) ||
                        null
                      }
                      defaultSelect="Select Preferred Bank"
                      onSelectOption={(option) =>
                        setData((prev) => ({
                          ...prev,
                          PreferBank: option.value,
                        }))
                      }
                      icon="feather-briefcase"
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <Input
                    label="Notes Title"
                    id="title"
                    type="text"
                    placeholder="Enter Notes Title"
                    value={data.title}
                    onChange={handleChange}
                    name="title"
                    icon="feather-hash"
                  />
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryStageModal;
